/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconProtocol = createReactComponent("outline", "protocol", "IconProtocol", [["path", { "d": "M15 6l-7 12", "key": "svg-0" }], ["path", { "d": "M20 6l-7 12", "key": "svg-1" }], ["path", { "d": "M5 14v.015", "key": "svg-2" }], ["path", { "d": "M5 10.015v.015", "key": "svg-3" }]]);

export { IconProtocol as default };
//# sourceMappingURL=IconProtocol.mjs.map
